<template>
  <fragment>
    <app-header title="Media Owner Tags"></app-header>

    <category-list :items="mediaOwnerTags">
      <template #add>
        <validation-observer tag="div" class="row" @submit.native.prevent ref="validation">
          <validation-provider tag="div" class="col" name="name" rules="required">
            <label>Add Media Owner Tag</label>
            <c-input type="text" v-model="stateName" />
            <c-help-block/>
          </validation-provider>
          <div class="col-auto">
            <c-button
              validate
              variant="primary"
              @click="save"
              class="mt-label"
            >
              Add
            </c-button>
          </div>
        </validation-observer>
      </template>
      <template #archive="{ item }">
        <button type="button" class="btn btn-sm text-warning" @click="handleArchive(item)">
          <i class="far fa-trash-restore" v-if="item.archived"></i>
          <i class="far fa-archive" v-else></i>
        </button>
      </template>
    </category-list>
  </fragment>
</template>
<script>
import { stateMapper, helperComputed, helperMethods } from '@/vuex/modules/settings/media-owner-tags'
import CategoryList from '@/components/settings/CategoryList'

export default {
  mixins: [
    stateMapper
  ],

  components: {
    CategoryList
  },

  created () {
    this.getMediaOwnerTags()
  },

  computed: {
    ...helperComputed
  },

  methods: {
    ...helperMethods,

    async save () {
      await this.storeMediaOwnerTag(this.mediaOwnerTag)
      this.resetMediaOwnerTag()
      this.$refs.validation.reset()
    },

    async handleArchive (item) {
      if (item.archived) {
        await this.updateMediaOwnerTag(item)
        this.resetMediaOwnerTag()
        this.getMediaOwnerTags({ fresh: true })
      } else {
        await this.deleteMediaOwnerTag(item.id)
        this.getMediaOwnerTags({ fresh: true })
      }
    }
  }
}
</script>
